import { LifeBuoy } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@shared/components/Button';

type UpdateRecoveryScreenProps = {
  onReload: () => void;
};

/**
 * Full-screen fallback shown when repeated update attempts fail to activate the
 * new build within the recovery window (see `useUpdateAttemptCounter`). It stops
 * the silent reload loop and hands the user an explicit manual-recovery action.
 */
export const UpdateRecoveryScreen = ({ onReload }: UpdateRecoveryScreenProps) => {
  const { t } = useTranslation();

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      className="fixed inset-0 z-[100] grid place-items-center bg-shell/95 px-6 text-white"
    >
      <div className="w-full max-w-md text-center">
        <div className="mx-auto mb-4 grid h-12 w-12 place-items-center rounded-full bg-signal-danger/20">
          <LifeBuoy className="h-6 w-6 text-signal-danger" aria-hidden="true" />
        </div>
        <h1 className="text-xl font-semibold">{t('appVersion.recovery.title')}</h1>
        <p className="mt-2 text-sm text-slate-300">{t('appVersion.recovery.body')}</p>
        <Button className="mt-6 w-full" onClick={onReload}>
          {t('appVersion.recovery.action')}
        </Button>
      </div>
    </div>
  );
};
